import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../utils/api';
import { SOCIAL_LINKS } from '../utils/constants';

export const DEFAULT_SETTINGS = {
  announcement: {
    enabled: true,
    messages: [
      'Festive Offer: Orders above Rs. 2,499 get 10% OFF automatically!',
      'Free Home Delivery on Orders Above Rs. 999!',
      'New Collection is Now Live — Shop Now!',
    ],
  },
  shipping: {
    freeShippingThreshold: 999,
    defaultShippingCharge: 50,
    codCharge: 50,
    codChargeByState: {},
    codAvailable: true,
    deliveryDays: 5,
  },
  autoDiscount: { enabled: true, minSubtotal: 2499, percent: 10 },
  social: {
    instagram: SOCIAL_LINKS.instagram,
    facebook: SOCIAL_LINKS.facebook,
    whatsapp: SOCIAL_LINKS.whatsapp,
    whatsappCommunity: SOCIAL_LINKS.whatsappCommunity,
  },
};

const SettingsContext = createContext({ settings: DEFAULT_SETTINGS, loading: true, refresh: () => {} });

const mergeSettings = (remote) => ({
  ...DEFAULT_SETTINGS,
  ...remote,
  announcement: { ...DEFAULT_SETTINGS.announcement, ...(remote?.announcement || {}) },
  shipping: { ...DEFAULT_SETTINGS.shipping, ...(remote?.shipping || {}) },
  autoDiscount: { ...DEFAULT_SETTINGS.autoDiscount, ...(remote?.autoDiscount || {}) },
  social: { ...DEFAULT_SETTINGS.social, ...(remote?.social || {}) },
});

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get('/settings');
      const remote = res.data?.data?.settings || res.data?.data;
      if (remote) setSettings(mergeSettings(remote));
    } catch {
      // keep defaults if settings endpoint unavailable
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const announcementHeight =
    settings.announcement?.enabled && settings.announcement?.messages?.length ? 34 : 0;

  return (
    <SettingsContext.Provider value={{ settings, loading, refresh, announcementHeight }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);

export default SettingsContext;
